export const APP_TITLE = process.env.APP_TITLE || ''
export const APP_DESCRIPTION = process.env.APP_DESCRIPTION || ''
export const APP_PRECONNECT_DOMAINS = process.env.APP_PRECONNECT_DOMAINS || ''
export const AS_API_DOMAIN = process.env.AS_API_DOMAIN || ''
export const AS_API_KEY = process.env.AS_API_KEY || ''
export const AS_ENABLE_CRPTOGRAPHY =
  process.env.AS_ENABLE_CRPTOGRAPHY === 'true'
export const AS_API_TIMEOUT = parseInt(process.env.AS_API_TIMEOUT || '', 10)

export const APP_MODE = process.env.APP_MODE || ''
export const APP_PAYPAL_CLIENT_ID = process.env.APP_PAYPAL_CLIENT_ID || ''
export const APP_HOME_URL = process.env.APP_HOME_URL || ''
export const APP_VERSION = process.env.APP_VERSION || ''
export const APP_ANDROID_URL = process.env.APP_ANDROID_URL || ''
